module.exports = __webpack_public_path__ + "img/three3Blue.3cc0bf1d.jpg";